import React, { useEffect, useState } from "react";
import Tabla from "./Tabla/index";
//import avisos_icon from "../../../assets/vw/svg/avisos.svg";
import ARCH from "../../../assets/vw/svg/archivo.svg";
import ARCH_AZUL from "../../../assets/vw/svg/archivo_azul.svg";
import AVISO from "../../../assets/vw/svg/aviso.svg";
import AVISO_AZUL from "../../../assets/vw/svg/aviso_azul.svg";
import Loading from "../../../components/Loading";
import TablaArchivo from "./TablaInactivos";
import Menu from "../../../components/Menu"
import Modal from "../../../components/Modal";
import NoInfoScreen from "../../../components/Screens/NoInfoScreen";


function Avisos(props) {
  const [dataAvisos, setDataAvisos] = useState([]);
  const [aviso, setAviso] = useState([]);
  const [avisosInactivas, setAvisosInactivas] = useState([]);
  const [inactivasFilter, setInactivasFilter] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [option, setOption] = useState("avisos");
  const [dataOriginal, setDataOriginal] = useState([]);
  const [aplicaciones, setAplicaciones] = useState([]);
  const [modal, setModal] = useState({
    active: false,
    message: '',
    success: false
  });

  async function getAvisos() {
    try {
      await getAplicaciones();
      setCargando(true);
      setModal({
        active: false,
        message: '',
        success: false
      });
      const response = await fetch(
        process.env.REACT_APP_URL_DTO_BACK + "avisos",
        {
          method: "GET",
          headers: {
            Authorization: "Bearer " + props.servicio.getToken(),
            "Content-Type": "application/json",
          },
        }
      );
      const data = await response.json();
      if (!response.ok) {
        throw new Error("Error en el feching de Avisos" + data.mensaje);
      }
      setDataOriginal(data.mensaje)
      const activas = data.mensaje.filter((aviso) => {
        return aviso.activo === 1;
      });
      setDataAvisos(activas);
      setCargando(false);
    } catch (error) {
      setCargando(false);
      setModal({
        active: true,
        message: error.message,
        success: false
      });
    }

  }

  async function getAplicaciones() {
    try {
      const response = await fetch(process.env.REACT_APP_URL_DTO_BACK + "aplicacion?todos", {
        method: "GET",
        headers: {
          Authorization: "Bearer " + props.servicio.getToken(),
          "Content-Type": "application/json",
        },
      });
      const data = await response.json();
      if (!response.ok) {
        return;
      }
      setAplicaciones(data.mensaje);
    } catch (error) {
    }
  }

  const handleChange = (e) => {
    setAviso([])
    setInactivasFilter([])
    if (option === "archivo") {
      filtrarInactivas(e.target.value)
    } else {
      filtrar(e.target.value);
    }

  };

  const filtrar = (terminoBusqueda) => {
    const resultado = dataAvisos.filter((element) => {
      if (
        element.titulos.toLowerCase().includes(terminoBusqueda.toLowerCase())
      ) {
        return element;
      }
      return "";
    });
    setAviso(resultado);
  };

  const filtrarInactivas = (terminoBusqueda) => {
    const resultado = avisosInactivas.filter((element) => {
      if (
        element.titulos.toLowerCase().includes(terminoBusqueda.toLowerCase())
      ) {
        return element;
      }
      return "";
    });
    setInactivasFilter(resultado);
  };

  const changeOption = (option) => {
    setAviso([])
    setInactivasFilter([])
    setOption(option);
    if (option === "archivo") {
      getAvisosInactivas(dataOriginal);
    }
  };

  const getAvisosInactivas = (data) => {
    const inactivas = data.filter((aviso) => {
      return aviso.activo === 0;
    });
    setAvisosInactivas(inactivas);
  };


  useEffect(() => {
    getAvisos();
  }, []);

  return (
    <>
      <Menu />
      <Modal modalInfo={modal} setMostrarModal={setModal} />
      {
        cargando && <Loading />
      }
      {
        aplicaciones.length !== 0 &&
        <div className={`navegacion`}>
        <>
            <div className=" posicionMenu">
              <ul className="d-flex flex-row px-0 my-0">
                <li
                  className="opcion-ruta"
                  onClick={() => changeOption("avisos")}
                >
                  <div
                    className={`nav-link nav-link-title active ps-0 ${option === "avisos" ? " active border_menu" : ""
                      }`}
                  >
                    <img
                      src={option === "avisos" ? AVISO_AZUL : AVISO}
                      alt="avisos"
                      className="icono-menu me-3"
                    />
                    Avisos
                  </div>
                </li>
                <li className="opcion-ruta" onClick={() => changeOption("archivo")}>
                  <div
                    className={`nav-link active ps-0  ${option === "archivo" ? " active border_menu" : ""
                      }`}
                  >
                    <img src={option === "archivo" ? ARCH_AZUL : ARCH} alt="archivo" className="icono-menu me-3" />
                    Archivo
                  </div>
                </li>
              </ul>
            </div>
            <div className="row border_vw pt-4 ms-0 mx-0">
              <div className="col-12 p-0 contenedor-table">
                {option === "archivo" ? (
                  <TablaArchivo
                    servicio={props.servicio} avisos={inactivasFilter && inactivasFilter.length > 0 ? inactivasFilter : avisosInactivas} aplicaciones = {aplicaciones} handleChange={handleChange}
                  />
                ) : (
                  <Tabla
                    servicio={props.servicio} avisos={aviso && aviso.length > 0 ? aviso : dataAvisos} aplicaciones = {aplicaciones} handleChange={handleChange}
                  />
                )}
              </div>
            </div>
        </>
        </div>
      }
    </>
  );
}

export default Avisos;
